import axios from 'axios'
import { Toast } from 'antd-mobile'
import { isShowLoading } from '../api/automobileInsurance'
import Loading from '../module/components/Loading'
import { getParam } from './utils'
import { ShareAddress } from '../api/automobileInsurance'

const TIMEOUT = 120000 // 超时时间

let axiosIns = axios.create({})
/*axiosIns.defaults.baseURL = baseURL*/
axiosIns.defaults.headers.contentType = 'application/json;charset=UTF-8'
axiosIns.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'
axiosIns.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest'
// axiosIns.defaults.withCredentials = true;
axiosIns.defaults.responseType = 'json'
axiosIns.defaults.timeout = TIMEOUT
let startTime
// axiosIns.defaults.transformRequest = [function (data) {
//   //数据序列化
//   return qs.stringify(data);
// }
// ];
axiosIns.defaults.validateStatus = function (status) {
  return true
}
axiosIns.interceptors.request.use(
  (config) => {
    startTime = new Date().getTime()
    let xtoken
    if (sessionStorage.getItem('xtoken')) {
      xtoken = sessionStorage.getItem('xtoken')
      console.log('agent-token', xtoken)
    } else if (localStorage.getItem('customer-token')) {
      xtoken = localStorage.getItem('customer-token')
      console.log('customer-token', xtoken)
    }
    if (config.url != ShareAddress) {
      if (
        config.url &&
        config.url.indexOf('/v1/confirmPaymentByOrderId') > -1
      ) {
        config.headers['X-Token'] = getParam('X-Token')
      } else if (xtoken) {
        config.headers['X-Token'] = xtoken
        if (
          config.url &&
          config.url.indexOf('/v1/qrCode/getQRCodeByOrderId') > -1
        ) {
          config.responseType = 'blob'
        }
      }
    }

    //配置config
    let url: any = config.url
    url = url ? url.split('?')[0] : url

    // isShowLoading.indexOf(url) > -1 && Loading.show()

    console.log(isShowLoading.indexOf(url))
    console.log(config.headers)
    config.headers.Accept = 'application/json'
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

axiosIns.interceptors.response.use(
  (response) => {
    let url: any = response.config.url
    url = url ? url.split('?')[0] : url
    // isShowLoading.indexOf(url) > -1 && Loading.hide()
    // console.log(url, isShowLoading)

    let status = response.status
    let errCode = response.data.code
    let errMsg = response.data.msg
    if (status === 200) {
      console.log(url + ' 请求成功', response.data)
      if (errCode == '0000') {
        return Promise.resolve(response)
      } else if (errCode == '5300') {
        return Promise.reject(response)
      } else if (errCode == '0001') {
        return Promise.reject(response)
      } else if (errCode == '1102') {
        //次数超限
        return Promise.reject(response)
      } else if (errCode == '93173') {
        //多人使用
        return Promise.reject(response)
      } else if (
        errCode == '5931' ||
        errCode == '5933' ||
        errCode == '5932' ||
        errCode == '5934' ||
        errCode === '5936' ||
        errCode === '5937'  // 充电桩提示
      ) {
        return Promise.reject(response)
      } else if (errCode == '5108') {
        return Promise.reject(response)
      } else if (errCode == '3001') {
        //缴费申请接口跳转双录链接
        return Promise.reject(response)
      } else if (errCode === '0032' || errCode === '0031') {
        // 员工车预约时间校验
        return Promise.reject(response)
      } else if (!errCode) {
        return Promise.resolve(response)
      } else {
        errMsg && Toast.info(errMsg)
        return Promise.reject(response)
      }
    } else {
      console.error(url + ' 请求失败', response)
      if (errCode == '4001') {
        return Promise.reject(response)
      } else {
        Toast.info('数据请求异常')
        return Promise.reject(response)
      }
    }
  },
  (err) => {
    console.error('http error', err)
    console.error(
      'http err.config.maxContentLength',
      err.config.maxContentLength
    )
    let url: any = err.config.url
    url = url ? url.split('?')[0] : url

    // isShowLoading.indexOf(url) > -1 && Loading.hide()
    //先去掉请求超时、请求失败这些提示
    // if(err.config.maxContentLength===-1){
    // 	let endTime = new Date().getTime();
    // 	let duringMillisecond = endTime-startTime;
    // 	console.error("duringMillisecond",duringMillisecond);
    // 	if(duringMillisecond>TIMEOUT){
    // 		Toast.info('请求超时');
    // 	}else{
    // 		Toast.info('请求失败，请检查网络链接是否正常');
    // 	}
    // }else{
    // 	Toast.info('服务异常，请稍后再试');
    // }
    return Promise.reject(err)
  }
)

let axiosMethod = ['get', 'post', 'patch', 'put']
let http = {}
axiosMethod.forEach((method) => {
  //数组取值的两种方式
  http[method] = function (uri: string, data: any, config: any) {
    return new Promise(function (resolve, reject) {
      console.log('http-url', uri)
      if (data) {
        console.log('http-params', data)
      }
      axiosIns[method](uri, data, config)
        .then((response: any) => {
          resolve(response)
        })
        .catch((response: any) => {
          reject(response)
        })
    })
  }
})

export default http
